// extracted by mini-css-extract-plugin
export default {"stringKey":"StringsEditor_stringKey__6FJIk"};